/**
 * Store listing URLs for the native mobile apps.
 * Apple ID from App Store Connect -> App Information -> General Information.
 * The Play URL is derived from the Capacitor appId (capacitor.config.ts).
 * @readonly
 */
export const APP_STORE_URL = "https://apps.apple.com/app/id6765471576";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.articulearn.app";

/**
 * Google approved the Android listing; Apple is still reviewing. While this is
 * false the App Store badge and the Safari Smart App Banner are suppressed,
 * because the App Store URL 404s until the listing is published.
 *
 * To turn iOS on: set this to true, uncomment the apple-itunes-app meta tag in
 * public/index.html, restore the two-platform wording in FAQView.vue, and
 * deploy. `git grep IOS_LIVE` finds every site that needs the flip.
 */
export const IOS_LIVE = true;
